export default {
  title: 'No. 1 partner in business property management.'
}